import React from 'react';
import styled from 'styled-components';
import { DatePicker } from '@material-ui/pickers';

const StyledDatePicker = styled(DatePicker)`
  position: relative;
  :after {
    content: ' ';
    position: absolute;
    top: 50%;
    right: 0.5rem;
    height: 1rem;
    width: 1rem;
    background: url('/images/calendar-img.png');
    background-size: cover;
    transform: translateY(-50%);
  }
`;

export const CustomDatePicker = ({
  label,
  name,
  date,
  handleDateSelect,
  minDate,
  disabled,
  format = 'MM/DD/YYYY',
  className = '',
  disablePast = false,
  size,
  maxDate,
}) => (
  <StyledDatePicker
    size={size}
    disableToolbar
    variant="inline"
    required
    label={label}
    format={format}
    name={name}
    value={date}
    minDate={minDate}
    onChange={date => handleDateSelect(date, name)}
    animateYearScrolling
    inputVariant="outlined"
    disabled={disabled}
    className={className}
    disablePast={disablePast}
    emptyLabel={label}
    maxDate={maxDate}
  />
);
